import { RegisterTeamActivityStatus } from 'app/api/event/model'
import { BaseTabs } from 'app/components/common/BaseTabs'
import { SectionBase } from 'app/components/common/SectionBase'
import { useGetActionNotJoinByTeam } from 'app/react-query/hook/event'
import { useMemo, useState } from 'react'
import { LabelComponent, TabKeysEnum } from '../components'
import { useActionRegisteredByStatusHook } from './hook'
import {
  ActionOpenRegisterLayout,
  ActionRegisteredByStatusLayout,
} from './layouts'

const RegisterActionForTeamContainer = () => {
  const [tab, setTab] = useState(TabKeysEnum.OPEN)
  const { data: response, isLoading } = useGetActionNotJoinByTeam()

  const dataOpen = useMemo(() => {
    return response?.data?.map((item, index) => {
      return {
        ...item,
        key: index + 1,
        index: index + 1,
      }
    })
  }, [response])

  const waitingHook = useActionRegisteredByStatusHook({
    status: RegisterTeamActivityStatus.WAITING,
  })

  const acceptedHook = useActionRegisteredByStatusHook({
    status: RegisterTeamActivityStatus.ACCEPTED,
  })

  const rejectedHook = useActionRegisteredByStatusHook({
    status: RegisterTeamActivityStatus.REJECTED,
  })

  const canceledHook = useActionRegisteredByStatusHook({
    status: RegisterTeamActivityStatus.CANCELED,
  })

  return (
    <SectionBase title="Đăng ký đội nhóm dành cho cán bộ công đoàn đơn vị">
      <BaseTabs
        tabPosition={'top'}
        onChange={key => setTab(key as TabKeysEnum)}
        items={[
          {
            label: (
              <LabelComponent
                label="Đang mở đăng ký"
                tabActive={tab}
                tabKey={TabKeysEnum.OPEN}
                count={dataOpen?.length}
              />
            ),
            children: (
              <ActionOpenRegisterLayout
                data={dataOpen ?? []}
                isLoading={isLoading}
              />
            ),
            key: `${TabKeysEnum.OPEN}`,
          },
          {
            label: (
              <LabelComponent
                label="Đã đăng ký, chờ duyệt"
                tabActive={tab}
                tabKey={TabKeysEnum.WAITING}
                count={waitingHook?.data?.length}
              />
            ),
            children: (
              <ActionRegisteredByStatusLayout
                data={waitingHook?.data ?? []}
                isLoading={waitingHook?.isLoading}
                status={RegisterTeamActivityStatus.WAITING}
              />
            ),
            key: `${TabKeysEnum.WAITING}`,
          },
          {
            label: (
              <LabelComponent
                label="Đã được duyệt"
                tabActive={tab}
                tabKey={TabKeysEnum.ACCEPTED}
                count={acceptedHook.data?.length}
              />
            ),
            children: (
              <ActionRegisteredByStatusLayout
                data={acceptedHook?.data ?? []}
                isLoading={acceptedHook?.isLoading}
                status={RegisterTeamActivityStatus.ACCEPTED}
              />
            ),
            key: `${TabKeysEnum.ACCEPTED}`,
          },
          {
            label: (
              <LabelComponent
                label="Bị từ chối"
                tabActive={tab}
                tabKey={TabKeysEnum.REJECTED}
                count={rejectedHook?.data?.length}
              />
            ),
            children: (
              <ActionRegisteredByStatusLayout
                data={rejectedHook?.data ?? []}
                isLoading={rejectedHook?.isLoading}
                status={RegisterTeamActivityStatus.REJECTED}
              />
            ),
            key: `${TabKeysEnum.REJECTED}`,
          },
          {
            label: (
              <LabelComponent
                label="Đã huỷ"
                tabActive={tab}
                tabKey={TabKeysEnum.CANCELED}
                count={canceledHook?.data?.length}
              />
            ),
            children: (
              <ActionRegisteredByStatusLayout
                data={canceledHook?.data ?? []}
                isLoading={canceledHook?.isLoading}
                status={RegisterTeamActivityStatus.CANCELED}
              />
            ),
            key: `${TabKeysEnum.CANCELED}`,
          },
        ]}
      />
    </SectionBase>
  )
}

export default RegisterActionForTeamContainer
